import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * As we use an existing SVG to power SYOS,
 * rather than rendering on the fly, this is
 * the one part of the App which diverges from
 * traditional React components, so most of the
 * behaviour here is done through manual DOM
 * manipulation and triggering custom events.
 *
 * This component just renders the HTML.
 * Most of the work happens in `SeatMapContainer`
 * and inside `behaviours/enhanceSeats`.
 */
class BALevelSelectMap extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let sectionGraphic = this.props.sectionGraphic;

    /* eslint-disable react/no-danger */
    return sectionGraphic ? (
      <div
        ref={component => {
          this._sectionSelectMap = component;
          this._sectionSelectSvg = component && component.querySelector('svg');

          this._sections =
            component && component.querySelectorAll('#Levels > g');
          this._sectionLabels =
            component && component.querySelectorAll('g#Label')
              ? component.querySelector('g#Label').children
              : [];
        }}
        className={classnames({
          'syos-level-selector-price-types-map': true,
          'is-ready': this.props.isEnhanced
        })}
        dangerouslySetInnerHTML={{
          __html: sectionGraphic
        }}
      />
    ) : null;
  }
}
BALevelSelectMap.propTypes = {
  sectionGraphic: PropTypes.string,
  isEnhanced: PropTypes.bool
};

export default BALevelSelectMap;



// WEBPACK FOOTER //
// ./src/javascripts/components/BALevelSelectMap.js